import http from "./http";
import { notify } from "@/composables/useNotify";

function handleResponse(resp) {
	if (resp.data.err === 0) {
		return resp.data.data;
	}
	notify.error(resp.data.errdesc);
	return Promise.reject(resp.data);
}

function handleError(err) {
	notify.error(err?.response?.data?.errdesc);
	return Promise.reject(err?.response?.data || err);
}

export const ovReq = {
	get(url, config) {
		return http.get(url, config).then(handleResponse, handleError);
	},
	post(url, data, config) {
		return http.post(url, data, config).then(handleResponse, handleError);
	},
	put(url, data, config) {
		return http.put(url, data, config).then(handleResponse, handleError);
	},
};
